import { render } from "./CreateSale.vue?vue&type=template&id=2fd597c6&scoped=true"
import script from "./CreateSale.vue?vue&type=script&lang=js"
export * from "./CreateSale.vue?vue&type=script&lang=js"

import "./CreateSale.vue?vue&type=style&index=0&id=2fd597c6&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd597c6"]])

export default __exports__